import { useIonAlert } from "@ionic/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { isCompatibleBrowserPushNotification } from "./pushnotification";

export const useAvailableNotification = () => {
    const [isPresentAvailableNotification, setIsPresentAvailableNotification] = useState<boolean>(false);
    const [presentAlert] = useIonAlert();
    const { t } = useTranslation("common");

    if (!isCompatibleBrowserPushNotification() && !isPresentAvailableNotification) {
        setIsPresentAvailableNotification(true);
        presentAlert({
            header: t("GLOBAL.WARNING"),
            cssClass: "custom-alert",
            backdropDismiss: false,
            message: t("MESSAGES.NOTIFICATION_NOT_COMPATIBLE"),
            buttons: [
                {
                    text: t("GLOBAL.ACCEPT"),
                    role: "cancel",
                },
            ],
        }).catch(() => {});
    }
};
